import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%","height":"120vh","border":"7px solid red"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, " Componente 3 Botoom ", -1)

import LanguageSwitchComponent from '@/components/shared/Language/LanguageSwitchComponent.vue';
import { ref } from 'vue';
import {dateFormat} from '@/services/ui/GlobalFunctions';

export default /*#__PURE__*/_defineComponent({
  __name: 'View3Component',
  setup(__props) {

const horaa = ref({});

const horaActual = ()=> 
{
    horaa.value = new Date();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, [
      _createTextVNode(" Componente 3 "),
      _createVNode(LanguageSwitchComponent)
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, [
        _createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(new Date(),"dddd, MMMM Do YYYY")), 1),
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(horaa.value,'L')), 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (horaActual()))
      }, "Hora")
    ]),
    _hoisted_3
  ], 64))
}
}

})